export default function serializeUrl(defaultUrl, params) {
  // convert camelCase to snake_case
  const snakeParams = {};
  _.forEach(params, (value, key) => {
    const snakeKey = key.replace(/([A-Z]+)/g, $1 => '_' + $1.toLowerCase());
    snakeParams[snakeKey] = value;
  });

  return _.isEmpty(params)
    ? defaultUrl
    : defaultUrl + '?' + decodeURI($.param(snakeParams));
}
